import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import { Manifest } from 'services/action';

const initialState = {
  showDelete: false,
  isLoading: false,
};

export const ActionDeleted = ({
  manifest,
  legs,
  onSubmit,
  handleClose,
  onLegChanges,
  loading = false,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ showDelete, isLoading }, setState] = React.useState(initialState);

  const $handleClose = async () => {
    setState((prevState) => ({
      ...prevState,
      showDelete: false,
    }));
  };

  const $onSave = async () => {
    const req = await Dispatch(Manifest.$deleteLeg(manifest?.id, legs?.id));
    if (req?.message === 'success') {
      if (onSubmit) onSubmit();
      if (handleClose) handleClose();
      if (onLegChanges) onLegChanges();
    }
  }

  return (
    <div>
      <button
        className={cn(
          'btn btn-sm btn-danger w-100',
          isLoading ? 'btn-loading' : ''
        )}
        onClick={() =>
          setState((prevState) => ({
            ...prevState,
            showDelete: true,
          }))
        }
      >
        Hapus Tujuan
      </button>
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin akan hapus tujuan semua shipment ini?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $onSave()}
                disabled={StateForm?.loading}
              >
                Hapus Tujuan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
